import jamespot, { jFileLittle, resolveFileMimetype, resolveFilePath } from 'jamespot-user-api';
import React, { useCallback, useEffect, useState } from 'react';
import { JRCFileAvatar } from '../../../../../JRCFile/JRCFileAvatar';
import { JRCIcon } from '../../../../../JRCIcon/JRCIcon';
import { JRCLoader } from '../../../../../JRCLoader/JRCLoader';
import { fileSend } from '../../../JRCInputFile/utils/file.api';
import { FileWithId } from '../../../JRCInputFileAdvanced/JRCInputFileAdvancedRaw';
import { FileImage, FileName, FileRemove, FileWrapper } from '../JRCFormFile.styles';

export const File = ({
    file,
    index,
    token,
    step,
    attrName,
    onUploadSuccess,
    onDeleteSuccess,
}: {
    file: FileWithId;
    index: number;
    step: number;
    token: string | undefined;
    attrName: string;
    onUploadSuccess?: (response: jFileLittle, token: string) => void;
    onDeleteSuccess?: () => void;
}) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [idFile, setIdFile] = useState<number>(0);
    const [initialToken, setInitialToken] = useState<string | undefined>(token);
    const [currentStep, setCurrentStep] = useState<number>(-1);
    const [uploadedFile, setUploadedFile] = useState<jFileLittle | undefined>(undefined);

    const send = useCallback(
        async (file: FileWithId, token: string | undefined, name: string) => {
            //USE useCallback because this function is in dependencies of useEffect. If dependencies of send not change, so send ref don't change.
            setLoading(true);
            const response = await fileSend(file, token, name);
            if (response) {
                setInitialToken(response.token);
                setLoading(false);
                setUploadedFile(response.result);
                setIdFile(response.result.id);
                if (onUploadSuccess) {
                    onUploadSuccess(response.result, response.token);
                }
            } else {
                // create on UploadError
                setLoading(false);
            }
        },
        [onUploadSuccess],
    );

    useEffect(() => {
        // Step is used to download the files one by one
        if (file && step === index && currentStep !== step) {
            setCurrentStep(step);
            send(file, initialToken, attrName);
        }
    }, [step, file, initialToken, attrName, index, send, currentStep]);

    const removeFile = () => {
        setLoading(true);
        if (initialToken !== undefined) {
            jamespot.file
                .deleteFile(idFile, attrName, initialToken)
                .then((res) => {
                    if (onDeleteSuccess && res) {
                        onDeleteSuccess();
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return file ? (
        <FileWrapper isLoading={loading}>
            <FileImage>
                {uploadedFile === undefined ? (
                    <JRCLoader />
                ) : (
                    <JRCFileAvatar
                        uri={resolveFilePath(uploadedFile)}
                        mimetype={resolveFileMimetype(uploadedFile)}
                        size={40}
                    />
                )}
            </FileImage>
            <FileName>{file.name}</FileName>
            <FileRemove onClick={() => removeFile()}>
                <JRCIcon name="icon-times" color="primary" size={14} />
            </FileRemove>
        </FileWrapper>
    ) : (
        <></>
    );
};
